export enum VerifyStrings {
  // Messages
  InvalidUrl = 'h/Mq',
  CompanyNotFound = '//dv',
  SiteNotFound = 'TQ3c',
  NotSubsXvi = 'Jf42',
}
